define('views/modules/template/assignment/assignment-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/events/calendar-events',
    'services/i18n',
    // models & collections
    'collections/template/templates',
    'models/template/template',
    'models/parts/menu/datepicker',
    // views
    'views/modules/template/list/template-list',
    'views/modules/template/assignment/list/template-select-list-item',
    'views/parts/menu/menu-action',
    'src/views/form-view',
    // template
    'text!templates/modules/template/assignment/assignment-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    CalendarEvents,
    i18n,
    // models & collections
    CTemplates,
    MTemplate,
    MDatePicker,
    // views
    VTemplateList,
    VTemplateSelectListItem,
    VMenuAction,
    VForm,
    // template
    TAssignmentContent
) {

    var VAssignmentContent = VForm.extend({
        template: TAssignmentContent,

        regions: {
            list: '.template-list',
            menu: '.menu-actions'
        },

        initialize: function(opt) {
            this.selected = new MTemplate();

            _.extend(this, {
                group: opt.group,
                profile: opt.profile
            });

            var collection = this.collection = new CTemplates(),
                model = this.model,
                view = this.view = {
                    menu: new VMenuAction({
                        context: this,
                        onClick: this.onActionClick,
                        collection: new Backbone.Collection([
                            { title: i18n.t('messages:tooltip-add-template'), content: 'Assign template', btnClass: 'btn-tc-custom', icon: 'fa fa-check', itemClass: 'pull-right', callback: this.onAssignTemplateAction },
                            new MDatePicker({ title: 'Template start date', model: model, attribute: 'startDate' }),
                        ]),
                        tooltip: { container: this.regions.root }
                    }),
                    list: new VTemplateList({
                        collection: collection,
                        item: VTemplateSelectListItem,
                    })
                };

            this.listenTo(collection, { 'template:click': this.onTemplateClick });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            this.collection.fetch();

        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onTemplateClick: function(model, val) {
            this.selected = model;
            this.unselect();
        },

        onAssignTemplateAction: function() {
            this.submit();
        },

        onSubmit: function() {
            this.model.set({
                template: this.selected.id,
                group: this.group.id,
                user: this.profile.id,
            });
        },

        onSuccess: function() {
            CalendarEvents.templateAssign();
        },

        unselect: function() {
            this.$('.template-select-list-item.active').removeClass('active');
        },

    });

    return VAssignmentContent;

});

